import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useLocation, useParams } from "react-router-dom";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { getPermissions } from "../rbac/hasAccess";
import { formateDate, paginationrowsPerPageOptions } from "../../../utils/commonComponent/commonConstant";
import { Tooltip } from "@mui/material";
import { submitSiteDelete } from "../../../utils/commonComponent/delete";
import { AutoCompletes, DateInput, TextFields } from "../../../utils/Custom/custominput";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../../global";
import { toast } from "react-toastify";
import { AddButton } from "../../../utils/Custom/Button";

const headers = ["id", "customerName", "enquiryNo"];

const fields = [
  { value: "customerName", label: "Client" },
  { value: "enquiryNo", label: "Enquiry No" },
];

const QuotationFollowUp = (props) => {
  const params = useParams();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleDelete = (row) => submitSiteDelete("quotationFollowup", row.id);

  const [followUpList, setFollowUpList] = React.useState([]);
  const [inputState, setInputState] = useState({
    quotationId: params.id,
    estimateClosureDate: null,
    remark: null,
    conversionRatio: null,
  });
  const [totalRows, setTotalRows] = useState(0);
  // Pagination states
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const updateEnquiryObject = (key, value) => {
    let newEnquiryObject = {
      ...inputState,
    };
    newEnquiryObject[key] = value;
    setInputState({ ...newEnquiryObject });
  };

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
    sessionStorage.setItem("ListPageCount", page);
    sessionStorage.setItem("ListRowsPerPage", rows);
  };

  const getWhereClause = () => {
    let whereConditions = `where quotationId = ${params.id}`;
    return whereConditions;
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();
    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${
        rowsPerPage * Number(currentPage)
      }`;
    }
    return `SELECT * FROM quotationFollowup ${whereClause} ORDER BY id DESC ${paginationSettings};`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();
    return `SELECT COUNT(*) AS totalRows FROM quotationFollowup ${whereClause};`;
  };

  const fetchData = async () => {
    try {
      const [enquiryList, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);
      let modifiedData = enquiryList?.map((item) => {
        return {
          ...item,
          Items: item.subcategory || "",
        };
      });
      setFollowUpList(modifiedData);
      setTotalRows(countResult?.[0]?.totalRows || 0);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const getData = async (event) => {
    let url = BASE_URL;
    const [res] = await fetchQuery(`SELECT id, clientId, quotationNumber FROM quotation q WHERE id = ${params.id}`);
    updateEnquiryObject("enquiryName", res?.clientId);
  };

  const addFollowupData = () => {
    let url = BASE_URL;
    const { enquiryName, ...payload } = inputState;
    axiosWithToken
      .post(url + "quotationFollowup", payload)
      .then((res) => {
        toast("Followup created successfully !");
        fetchData();
        updateEnquiryObject("remark", null);
        updateEnquiryObject("estimateClosureDate", null);
        updateEnquiryObject("conversionRatio", null);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getData();
    fetchData();
  }, []);

  return (
    <div>
      <div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 my-4">
          <div className="w-full">
            <TextFields
              label="Client *"
              value={inputState?.enquiryName || ""}
              onChange={(e) => {
                updateEnquiryObject("enquiryName", e.target.value);
              }}
              disabled
            />
          </div>
          <div className="w-full">
            <TextFields
              label="Remark *"
              value={inputState?.remark || ""}
              multiline
              onChange={(e) => {
                updateEnquiryObject("remark", e.target.value);
              }}
            />
          </div>
          <div className="w-full">
            <DateInput
              id="estimateClosureDate"
              label={"Estimate Closure Date"}
              value={
                inputState.estimateClosureDate
                  ? new Date(inputState.estimateClosureDate)
                  : ""
              }
              onChange={(value) =>
                updateEnquiryObject("estimateClosureDate", value)
              }
            />
          </div>
          <div className="w-full">
            <TextFields
              label="Conversion Ratio *"
              value={inputState?.conversionRatio || ""}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                updateEnquiryObject("conversionRatio", value);
              }}
            />
          </div>
          <div className="w-full">
            {(permissions.create || permissions.allAccess) && (
              <AddButton
                id="btn-add-outline"
                label="Add "
                onClick={() => addFollowupData()}
                disabled={!inputState.remark || !inputState.estimateClosureDate}
              />
            )}
          </div>
        </div>
      </div>

      <div className="w-full border rounded-md shadow">
        <div className="overflow-y-auto h-auto max-h-[550px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs font-medium text-gray-600 z-10">
              <tr>
                <th className="px-4 py-3 whitespace-nowrap">Sr. No.</th>
                <th className="px-4 py-3 whitespace-nowrap">Remark</th>
                <th className="px-4 py-3 whitespace-nowrap">
                  Estimate Closure Date
                </th>
                <th className="px-4 py-3 whitespace-nowrap">
                  Conversion Ratio
                </th>
                {(permissions.delete || permissions.allAccess) && (
                  <th className="px-4 py-3 whitespace-nowrap">Actions</th>
                )}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {followUpList?.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td className="px-4 py-3">
                    {currentPage * rowsPerPage + rowIndex + 1}
                  </td>
                  <td className="px-4 py-3 cursor-pointer hover:text-blue-600">
                    {row.remark ?? "-"}
                  </td>
                  <td className="px-4 py-3">
                    {formateDate(row.estimateClosureDate) ?? "-"}
                  </td>
                  <td className="px-4 py-3">{row.conversionRatio ?? "-"}</td>
                  <td className="px-4 py-2 text-center whitespace-nowrap">
                    <div className="flex items-center gap-2">
                      {(permissions.delete || permissions.allAccess) && (
                        <Tooltip title="Delete" placement="top-start">
                          <button
                            onClick={() => handleDelete(row)}
                            className="text-blue-600"
                          >
                            <DeleteIcon fontSize="small" />
                          </button>
                        </Tooltip>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
              {followUpList.length === 0 && (
                <tr>
                  <td
                    colSpan={headers.length + 1}
                    className="text-center py-4 text-gray-500"
                  >
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between px-4 py-2 bg-blue-50 text-sm border-t">
          <div className="flex items-center gap-2">
            <span>Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) =>
                handlePaginationChange(0, Number(e.target.value))
              }
              className="border rounded px-2 py-1 text-sm"
            >
              {paginationrowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-gray-600">
              {totalRows === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                    (currentPage + 1) * rowsPerPage,
                    totalRows
                  )} of ${totalRows}`}
            </span>
            <button
              onClick={() => handlePaginationChange(0, rowsPerPage)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() =>
                handlePaginationChange(currentPage - 1, rowsPerPage)
              }
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() =>
                handlePaginationChange(currentPage + 1, rowsPerPage)
              }
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() =>
                handlePaginationChange(
                  Math.ceil(totalRows / rowsPerPage) - 1,
                  rowsPerPage
                )
              }
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotationFollowUp;
